export default "__VITE_ASSET__C5ZTYQd9__"